module.exports = __webpack_public_path__ + "media/images/top/img_stationary_and_coffee-842e6169a3f06c54f64d66c5d4f0a4eb.png";